module.exports = __webpack_public_path__ + "03_face.b7ba0fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer1/03_face.png
// module id = 5Ya+
// module chunks = 0